'use client';

import { Tab as MuiTab, styled } from '@mui/material';
import type { ReactNode } from 'react';

import { campaignManagerTheme } from '@campaign-manager/theme';

interface Props {
  label: ReactNode | string;
  value: string;
}

const Tab = styled((props: Props) => <MuiTab {...props} />, {
  name: 'RmtTab',
})(() => ({
  paddingRight: 38,
  paddingLeft: 38,
  borderRadius: '12px',
  borderBottomRightRadius: 0,
  borderBottomLeftRadius: 0,

  lineHeight: '26px',
  color: campaignManagerTheme.color.darkGrey,

  backgroundColor: '#eaebec',
  '&.Mui-selected': {
    color: campaignManagerTheme.color.black,
    backgroundColor: '#fff',
    boxShadow: `
      0 -1px 0 0 rgba(0,0,0,0.04),
      -1px 0 0 0 rgba(0,0,0,0.04),
      1px 0 0 0 rgba(0,0,0,0.04),
      inset 0 1px 0 0 rgba(255,255,255,0.7)
    `,
  },
}));

export default Tab;
